/* Depor Fit - valor elegido en variantes + círculos con foto */
(function(){
  var NAMES = /guante|color|colour|diseño|modelo/i;
  var nav = document.querySelector('[data-df-handle]');
  var handle = nav ? nav.getAttribute('data-df-handle') : null;
  var maps = null, names = [];

  function legendName(l){
    var n = l.childNodes[0];
    return n ? (n.textContent || '').trim() : '';
  }

  function labels(){
    document.querySelectorAll('fieldset.variant-option--buttons').forEach(function(f){
      var c = f.querySelector('input:checked'), l = f.querySelector('legend');
      if (!l) return;
      var s = l.querySelector('.df-sel');
      if (!s) { s = document.createElement('span'); s.className = 'df-sel'; l.appendChild(s); }
      var t = c ? ': ' + c.value : '';
      if (s.textContent !== t) s.textContent = t;
    });
  }

  function swatches(){
    if (!maps) return;
    document.querySelectorAll('fieldset.variant-option--buttons').forEach(function(f){
      var l = f.querySelector('legend');
      if (!l) return;
      var name = legendName(l), idx = names.indexOf(name);
      if (idx < 0 || !NAMES.test(name)) return;
      var map = maps[idx], any = false;
      f.querySelectorAll('label').forEach(function(lb){
        var inp = lb.querySelector('input');
        if (!inp) return;
        var src = map[inp.value];
        if (!src) return;
        any = true;
        if (lb.querySelector('.df-sw')) return;
        var i = document.createElement('img');
        i.className = 'df-sw'; i.src = src; i.alt = inp.value; i.loading = 'lazy';
        lb.appendChild(i); lb.title = inp.value;
      });
      if (any && !f.classList.contains('df-swf')) f.classList.add('df-swf');
    });
  }

  function run(){ labels(); swatches(); }

  if (handle) {
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        names = (p.options || []).map(function(o){ return typeof o === 'string' ? o : o.name; });
        maps = names.map(function(){ return {}; });
        (p.variants || []).forEach(function(v){
          var img = v.featured_image && v.featured_image.src;
          if (!img) return;
          var sized = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          [v.option1, v.option2, v.option3].forEach(function(val, k){
            if (val != null && maps[k] && !maps[k][val]) maps[k][val] = sized;
          });
        });
        run();
      })
      .catch(function(){});
  }

  document.addEventListener('change', function(e){
    if (e.target.closest && e.target.closest('variant-picker')) setTimeout(run, 0);
  });
  var tm;
  function start(){
    run();
    new MutationObserver(function(){ clearTimeout(tm); tm = setTimeout(run, 80); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
